import apiClient from './apiClient'
import { MCPServer } from './mcpServer'

export interface RemoteMCPServer {
  id: number
  name: string
  description: string | null
  slug: string
  remote_url: string
  enabled: boolean
  transport_type: string
}

/** Union of room-scoped stdio servers and global remote (OAuth) servers. */
export type AnyMCPServer = MCPServer | RemoteMCPServer

export interface RemoteMCPConnection {
  id: number
  mcp_server: RemoteMCPServer
  is_active: boolean
  token_expires_at: string | null
  created_at: string
}

export const listRemoteMCPServers = async (): Promise<RemoteMCPServer[]> => {
  const response = await apiClient.get<RemoteMCPServer[]>('/oge/chatbot/mcp/servers/')
  return response.data
}

export const startRemoteMCPOAuth = async (
  serverId: number
): Promise<{ auth_url: string }> => {
  const response = await apiClient.post<{ auth_url: string }>(
    `/oge/chatbot/mcp/servers/${serverId}/oauth/start/`
  )
  return response.data
}

export const listRemoteMCPConnections = async (): Promise<RemoteMCPConnection[]> => {
  const response = await apiClient.get<RemoteMCPConnection[]>('/oge/chatbot/mcp/connections/')
  return response.data
}

export const disconnectRemoteMCP = async (connId: number): Promise<void> => {
  await apiClient.delete(`/oge/chatbot/mcp/connections/${connId}/`)
}

export const fetchRoomOwnerMCPConnections = async (
  roomId: string
): Promise<{ connected_server_ids: number[] }> => {
  const response = await apiClient.get<{ connected_server_ids: number[] }>(
    `/oge/chatbot/rooms/${roomId}/mcp/owner-connections/`
  )
  return response.data
}
